import React from 'react'
import NextHead from 'next/head'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import { BRAND_NAME_TITLE as brand } from 'src/constants/business'
import { buildCanonicalURL } from 'lib/utils/page'
import { getJsonLd } from 'client/components/JsonLd/utils'

import HrefLangs from 'src/comps/HrefLangs'
import messages from './messages'
import { useMarket } from 'src/hooks/useMarket'

const Head = ({ pathname, city = '', totalTesults = '' }) => {
  const intl = useIntl()
  const { subdomain, topdomain, language, market } = useMarket()

  const title = intl.formatMessage(messages.title, {
    city_name: city,
    total_results: totalTesults,
  })
  const description = intl.formatMessage(messages.description, { city_name: city, brand })
  const canonicalURL = buildCanonicalURL({ pathname, market, language, subdomain, topdomain })

  return (
    <>
      <NextHead>
        <title>{title}</title>
        <meta name="title" content={title} />
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <link rel="canonical" href={canonicalURL} />
        <script type="application/ld+json">{getJsonLd(market)}</script>
      </NextHead>
      <HrefLangs pathname={pathname} />
    </>
  )
}

Head.propTypes = {
  city: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  totalTesults: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default Head
